import React, { useRef, useState, useEffect } from "react";
import UiPanel from "./UiPanel";

function CenterUI({ config }) {
  const hideUI = config.hideUI || false;

  const iframeRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const handleIframeLoad = () => {
    setIsLoaded(true);
    // You can also interact directly with the iframe here if needed
    console.log("Iframe loaded:", iframeRef.current);
  };

  return (
    <div style={{justifyContent:'center', alignItems:'center', display:'flex'}}>
      <div className="mainElem">
        <div className="CenterUI">
          {hideUI ? <></> : <UiPanel iframeRef={iframeRef} />}
            <iframe
              ref={iframeRef}
              onLoad={handleIframeLoad}
              src={config.initalUrl}
              className="IframeComponent"
              frameBorder="0"
              allowFullScreen
              title="App iframe"
            ></iframe>
        </div>
      </div>
    </div>
  );
}

export default CenterUI;
